export const WINDOW_RESIZE = 'WINDOW_RESIZE';
export const CHECK_LOCK = 'CHECK_LOCK';
export const LOCK_DATE = +new Date(2020, 12, 25);
export const GIFT_TYPE = {
  ACHAT: 'achat',
  PARTICIPATION: 'participation'
};
